export default {
    getSelectedProduct(state) {
        return state.selected_product
    },
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/getters/selectedProductGetters.js